import { ExploreProvider } from '/Scripts/common/react-new/exploreContext.jsx';

export const App = ({ children = null, isAuthenticated = true }) => {
	return (
		<ExploreProvider isAuthenticated={isAuthenticated}>
			{children}
		</ExploreProvider>
	);
}